
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Users } from "lucide-react";
import { useCountry } from "@/contexts/country";

const JoinMovementSection = () => {
  const { countryName, countryCode } = useCountry();

  if (!countryName || !countryCode) {
    return null;
  }

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-nation-purple via-nation-blue to-nation-teal relative overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center text-white">
          <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Users className="h-10 w-10 text-white" />
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Join the {countryName} Movement
          </h2>
          
          <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
            Be part of the democratic revolution. Your voice matters in shaping {countryName}'s future.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              className="bg-white text-nation-purple hover:bg-gray-100 font-semibold px-8 py-4"
              asChild
            >
              <Link to="/solutions/verified-pollsters">
                Become a Verified Pollster <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <Button
              size="lg"
              variant="outline"
              className="border-white text-white hover:bg-white/10 px-8 py-4"
              asChild
            >
              <Link to={`/cards/${countryCode}`}>
                Explore Issues
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinMovementSection;
